import { ThunkAction } from 'redux-thunk'
import * as ActionTypes from 'store/types/common.type'
import { State } from 'store/reducers/common.reducer'

const startLoading = () => ({ type: ActionTypes.COMMON_LOADING })
const successMessage = (success?: string) => ({ type: ActionTypes.COMMON_SUCCESS, success })
const errorMessage = (error?: string) => ({ type: ActionTypes.COMMON_ERROR, error })
export const commonReset = () => ({ type: ActionTypes.COMMON_RESET })

export type Actions = ReturnType<typeof startLoading> | ReturnType<typeof successMessage> | ReturnType<typeof errorMessage> | ReturnType<typeof commonReset>

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export const commonLoading = (): ThunkResult<void> => dispatch => {
    dispatch(startLoading())
}
export const commonSuccess = (success?: string): ThunkResult<void> => dispatch => {
    dispatch(successMessage(success))
    setTimeout(() => dispatch(commonReset()), 5000)
}
export const commonError = (error?: string): ThunkResult<void> => dispatch => {
    dispatch(errorMessage(error))
    setTimeout(() => dispatch(commonReset()), 5000)
}


